import axios from 'axios';
import _get from 'lodash/get';
import { searchBarFPTIs } from '../../helpers/analytics/homePageAnalytics';
import { trackActivityEvent } from '../../helpers/analytics/fptiHelper';

export const REQUEST_TOP_SEARCH_REASONS = 'REQUEST_TOP_SEARCH_REASONS';
export const RECEIVE_TOP_SEARCH_REASONS = 'RECEIVE_TOP_SEARCH_REASONS';
export const RECEIVE_TOP_SEARCH_REASONS_ERROR = 'RECEIVE_TOP_SEARCH_REASONS_ERROR';

export const UPDATE_SEARCH_QUERY = 'UPDATE_SEARCH_QUERY';
export const RESET_SEARCH = 'RESET_SEARCH';
export const REQUEST_SEARCH_SUGGESTIONS = 'REQUEST_SEARCH_SUGGESTIONS';
export const RECEIVE_SEARCH_SUGGESTIONS = 'RECEIVE_SEARCH_SUGGESTIONS';
export const UPDATE_SEARCH_SUGGESTIONS_FROM_CACHE = 'UPDATE_SEARCH_SUGGESTIONS_FROM_CACHE';
export const RECEIVE_SEARCH_SUGGESTIONS_ERROR = 'RECEIVE_SEARCH_SUGGESTIONS_ERROR';

const defaultSize = 5;
const suggestionsCache = {};

const requestTopSearchReasons = () => ({
  type: REQUEST_TOP_SEARCH_REASONS,
});

const receiveTopSearchReasonsResponse = (payload, customtopContactReasons) => ({
  type: RECEIVE_TOP_SEARCH_REASONS,
  payload,
  customtopContactReasons,
});

const receiveTopSearchReasonsError = () => ({
  type: RECEIVE_TOP_SEARCH_REASONS_ERROR,
});

/**
 * Function to fetch top 5 search reasons results
 */
const filterTopSearchReasonsResponse = (responseData) =>
  responseData.slice(0, defaultSize).map((article) => ({
    title: article.articleTitle,
    docid: article.articleId,
  }));

// Get top contact Reason as default search selection
// if ocp is present take the first ocp .
// if bna present but not ocp take the first bna
// if both not prsent take the result of related call
export const getTopSearchReasons = (ocpData, bnaData) => (dispatch) => {
  dispatch(requestTopSearchReasons());
  let topReasonsURL = '';
  let customTopContactReasons = false;
  const getOCPData = _get(ocpData, 'intentDetails[0].channelDetails.customerIntent');
  const getBNAData = _get(bnaData, 'bnas[0].articleTitle');
  if (getOCPData) {
    topReasonsURL = `/smarthelp/km-full-search?q=${getOCPData}`;
    customTopContactReasons = true;
  } else if (getBNAData) {
    topReasonsURL = `/smarthelp/km-full-search?q=${getBNAData}`;
    customTopContactReasons = true;
  } else {
    const defaultTopReasonQuery = 'HELPHUB_TOPCONTACTREASON';
    topReasonsURL = `/smarthelp/api/related-article?topic=${defaultTopReasonQuery}`;
  }
  return axios
    .get(topReasonsURL)
    .then((res) => {
      if (!Array.isArray(res.data) || !res.data.length) {
        // Dispatching error actions when API returns 200 with empty response
        dispatch(receiveTopSearchReasonsError());
      } else {
        if (customTopContactReasons) {
          trackActivityEvent(searchBarFPTIs.customtopContactReasonsDisplayed);
        }
        dispatch(receiveTopSearchReasonsResponse(filterTopSearchReasonsResponse(res.data), customTopContactReasons));
      }
    })
    .catch(() => {
      dispatch(receiveTopSearchReasonsError());
    });
};

const updateSearchQuery = (query) => ({
  type: UPDATE_SEARCH_QUERY,
  payload: query,
});

export const resetSearch = () => ({
  type: RESET_SEARCH,
});

const requestSearchSuggestions = (query) => ({
  type: REQUEST_SEARCH_SUGGESTIONS,
  payload: { query },
});

const updateSearchSuggestionsFromCache = (query, autoComplete) => ({
  type: UPDATE_SEARCH_SUGGESTIONS_FROM_CACHE,
  payload: { query, autoComplete },
});

const receiveSearchSuggestions = (query, autoComplete) => ({
  type: RECEIVE_SEARCH_SUGGESTIONS,
  payload: { query, autoComplete },
});

const receiveSearchSuggestionsError = () => ({
  type: RECEIVE_SEARCH_SUGGESTIONS_ERROR,
});

export const getSearchSuggestions = (query) => (dispatch) => {
  dispatch(requestSearchSuggestions(query));
  const url = `/smarthelp/api/km-search-auto-complete?q=${query}`;
  return axios
    .get(url)
    .then((response) => {
      const { autoComplete } = response.data;
      if (Array.isArray(autoComplete) && autoComplete.length) {
        suggestionsCache[query] = autoComplete; // update the cache
      } else {
        // success response with empty array fire FPTI
        const fptiOptions = {
          ...searchBarFPTIs.autoSuggestionEmptyResponse,
          ...{
            srch: query,
          },
        };
        trackActivityEvent(fptiOptions); // Auto Suggestion Empty Response FPTI
      }
      dispatch(receiveSearchSuggestions(query, autoComplete));
    })
    .catch(() => {
      const fptiOptions = {
        ...searchBarFPTIs.autoSuggestionError,
        ...{
          srch: query,
        },
      };
      trackActivityEvent(fptiOptions); // Auto Suggestion Error FPTI
      dispatch(receiveSearchSuggestionsError());
    });
};

/**
 * Function to check the cache for autocomplete results for the given query
 */
export const updateSearchSuggestions = (query) => (dispatch) => {
  dispatch(updateSearchQuery(query));
  if (query in suggestionsCache) {
    dispatch(updateSearchSuggestionsFromCache(query, suggestionsCache[query]));
  } else {
    dispatch(getSearchSuggestions(query));
  }
};
